import { render, staticRenderFns } from "./evalCriteriaComp.vue?vue&type=template&id=c78a9560"
import script from "./evalCriteriaComp.vue?vue&type=script&lang=js"
export * from "./evalCriteriaComp.vue?vue&type=script&lang=js"
import style0 from "./evalCriteriaComp.vue?vue&type=style&index=0&id=c78a9560&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports